import React from "react";
import useRequest from "../../../Utils/useRequest";
import { ExamTimeItem, getExamTime } from "../../../API";
import LoadingWrapper from "../../../components/LoadingWrapper";
import { Table } from "antd";
import { ColumnProps } from "antd/lib/table/interface";
import Style from "../../main/main.module.scss";
import { useHeaderProps } from "../../../components/Layouts/SubLayout/useHeaderProps";

export default function PageExamTime() {
    const [data, { loading }] = useRequest(getExamTime);

    useHeaderProps({ title: "考试安排" });

    const columns: ColumnProps<ExamTimeItem>[] = [
        {
            title: "课程号",
            dataIndex: "courseNo"
        },
        {
            title: "课程序号",
            dataIndex: "courseSeq"
        },
        {
            title: "课程名",
            dataIndex: "courseName"
        },
        {
            title: "试卷名称",
            dataIndex: "examName"
        },
        {
            title: "开始时间",
            dataIndex: "beginTime"
        },
        {
            title: "结束时间",
            dataIndex: "endTime"
        },
        {
            title: "校区",
            dataIndex: "schoolZone"
        },
        {
            title: "教学楼",
            dataIndex: "teachingBuilding"
        },
        {
            title: "教室",
            dataIndex: "classroom"
        },
        {
            title: "座位号",
            dataIndex: "seatNo"
        },
        {
            title: "备注",
            dataIndex: "content"
        }
    ];

    return (
        <div className={Style.main}>
            <LoadingWrapper
                loading={loading}
                isEmpty={!data || data.length === 0}
                emptyMessage="没有考试安排">
                {() => (
                    <Table
                        columns={columns}
                        dataSource={data || []}
                        scroll={{ x: 1000 }}
                    />
                )}
            </LoadingWrapper>
        </div>
    );
}
